function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettlersStatsOverlayTemplate = require('./stats.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var StatsOverlay = /*#__PURE__*/function () {
  function StatsOverlay(app, mod) {
    _classCallCheck(this, StatsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.dice_count = [];
  }
  return _createClass(StatsOverlay, [{
    key: "render",
    value: function render() {
      var winner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      this.overlay.show(SettlersStatsOverlayTemplate(this, winner));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      Array.from(document.querySelectorAll(".overlay-tab")).forEach(function (tab) {
        tab.onclick = function (e) {
          if (e.currentTarget.classList.contains("active-tab")) {
            return;
          }
          $(".active-tab").removeClass("active-tab");
          $(".active-page").removeClass("active-page");
          e.currentTarget.classList.add("active-tab");
          var id = e.currentTarget.id.split("-")[0];
          $("#".concat(id, "-page")).addClass("active-page");
        };
      });
    }
  }]);
}();
module.exports = StatsOverlay;